import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';

export const AuthExternalProviders: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => inject(AuthenticationService).checkProviderAuth(route);
